var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"activity"}},[_c('div',{staticClass:"main width1200"},[_c('div',{staticClass:"left"},[_c('activity-tree',{attrs:{"activityId":_vm.activityId}})],1),_vm._v(" "),_c('div',{staticClass:"right"},[_c('activity-detail')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02c20031","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity.vue
// module id = null
// module chunks = 